class SizeChart {
  constructor(parent) {
    if (!parent) {
      return;
    }
    this.parent = parent;
    this.clickEvent();
    this.onLoad();
  }
  onLoad = () => {
    // Product title in size chart
    let parent = this.parent;
    if(qs('.product-title-js')) {
      qs('.product-title-js').innerText = parent.dataset.title;
    }
  }

  toggleClass = () => {
    let parent = this.parent;
    let armadaModal = qs('.product-size-chart-modal');
    armadaModal.classList.toggle('hidden');
    qs('body').classList.toggle('overflow-hidden');
    qs('.product__info-container').classList.toggle('product__column-sticky');
  }

  clickEvent = () => {
    let parent = this.parent;
    let modalCloseButton = qs('.modal-close-button');
    let sizeChartOpen = qs('.product-size-chart-open',parent);
    let productSizeChartInner = qs('.product-size-chart-inner');
    sizeChartOpen?.addEventListener('click',(e)=> {
      this.toggleClass();
    })
    modalCloseButton?.addEventListener('click',(e)=> {
      this.toggleClass();
    })
    productSizeChartInner?.addEventListener('click',(e)=> {
      if(e.target !== e.currentTarget) return;
      this.toggleClass();
    })
    const sizeUnits = qsa('.size-units-js input');
    sizeUnits.length > 0 && sizeUnits.forEach(el=>{
      el.addEventListener('click',(e)=>{
        let parent = e.target.closest('.size-chart-modal-wrapper');
        qsa('.units-table',parent).forEach(unitEl=>{
            unitEl.classList.remove('active');
        })
        qs(el.dataset.class,parent).classList.add('active');
      })
    })
  }
}
new SizeChart(qs('.size-chart-js'));
